import React, { useContext, useState } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import EscrowPayments from "./escrowPayments";
import EscrowRefunds from "./escrowRefunds";
import { StateContext } from "../../utils/context";
import { Trans, useTranslation }from "react-i18next";

import "./escrowWallet.scss";

const EscrowWallet = () => {
    const { currentUser } = useContext(StateContext);
    const { t } = useTranslation();
    const [forceUpdate, setForce] = useState(1);
    return (
        <>
            <Row className="mb-3">
                <Col xm="12" sm="12" md="12" lg="12" xl="12">
                    <Card>
                        <CardBody>
                            <Row>
                                <Col xm="12" sm="8" md="8" lg="8" xl="10">
                                    <CardTitle>
                                        <h4>{t("escrowWallet.view.title")}</h4>
                                    </CardTitle>
                                    <Trans i18nKey="escrowWallet.view.descriptionParagraph1">
                                        Funds are withheld to ensure safety and transparency during the verification process. For flagged tracks, a fee of <b>15 €</b> per track is held in escrow to whitelist the track for delivery to Spotify. These funds will be refunded once the track’s artists are verified as legitimate.
                                    </Trans>
                                    <br /><br />
                                    <Trans i18nKey="escrowWallet.view.descriptionParagraph2">
                                        Use the table below to view all escrow transactions. For more details, <a href="#" target="_blank" rel="noopener noreferrer"><strong>Learn More</strong></a>
                                    </Trans>
                                </Col>
                                <Col xm="12" sm="2" md="2" lg="2" xl="1">
                                    <center><h6>{t("escrowWallet.view.label.totalWithheld")}</h6><br /><h4 className="text-danger">{currentUser.escrow_total_withheld} €</h4></center>
                                </Col>
                                <Col xm="12" sm="2" md="2" lg="2" xl="1">
                                    <center><h6>{t("escrowWallet.view.label.totalRefunds")}</h6><br /><h4 className="text-success">{currentUser.escrow_total_refunds} €</h4></center>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Row className="mt-2">
                <Col xm="12" sm="12" md="12" lg="12" xl="12">
                    <EscrowPayments forceUpdate={forceUpdate} setForce={setForce} />
                </Col>
            </Row>


            <Row className="mt-2">
                <Col xm="12" sm="12" md="12" lg="12" xl="12">
                    <EscrowRefunds forceUpdate={forceUpdate} setForce={setForce} />
                </Col>
            </Row>
        </>
    );
};

export default EscrowWallet;